import React, { useEffect } from 'react';
import { useGlobalPipelineProgress } from '~/contexts/GlobalPipelineProgressContext';
import { motion, AnimatePresence } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSync, faCheckCircle, faExclamationCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import './GlobalPipelineProgressBar.css';

export default function GlobalPipelineProgressBar() {
    const { pipeline, isRunning } = useGlobalPipelineProgress();

    useEffect(() => {
        if (isRunning) {
            document.body.classList.add('has-pipeline-progress');
        } else {
            document.body.classList.remove('has-pipeline-progress');
        }
        
        return () => {
            document.body.classList.remove('has-pipeline-progress');
        }
    }, [isRunning]);

    let bgColor = 'bg-primary';
    let icon = faSync;
    let isSpinning = true;
    const currentStatus = (pipeline?.status || '').toLowerCase();
    let message = `CI/CD Pipeline #${pipeline?.id} is ${currentStatus.toUpperCase()} (Branch: ${pipeline?.ref || pipeline?.ref_name}) - Please wait while the system is being updated...`;

    if (currentStatus === 'success') {
        bgColor = 'bg-success';
        icon = faCheckCircle;
        isSpinning = false;
        message = `CI/CD Pipeline #${pipeline?.id} SUCCESS! System has been updated.`;
    } else if (currentStatus === 'failed') {
        bgColor = 'bg-danger';
        icon = faExclamationCircle;
        isSpinning = false;
        message = `CI/CD Pipeline #${pipeline?.id} FAILED! Please check GitLab logs.`;
    } else if (currentStatus === 'canceled') {
        bgColor = 'bg-warning';
        icon = faTimesCircle;
        isSpinning = false;
        message = `CI/CD Pipeline #${pipeline?.id} CANCELED.`;
    }

    return (
        <AnimatePresence>
            {isRunning && pipeline && (
                <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 50, opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    className="global-pipeline-progress-container"
                >
                    <div 
                        className={`progress-bar progress-bar-striped progress-bar-animated ${bgColor} global-pipeline-progress-bar`} 
                        role="progressbar" 
                        aria-valuenow="100" 
                        aria-valuemin="0" 
                        aria-valuemax="100" 
                    >
                        <span className="text-white fw-bold fs-8-1 d-flex align-items-center">
                            <FontAwesomeIcon icon={icon} spin={isSpinning} className="me-2" />
                            {message}
                        </span>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
